<template>
  <div class="coming-page">
    <!-- 头部 -->
    <div class="header-footer-wrapper">
      <PageHeader />
    </div>
    
    <!-- 主体内容 -->
    <div class="coming-wrapper">
      <div class="coming-container">
        <div class="coming-content">
          <div class="icon-wrapper">
            <svg class="wrench-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M14.7 8.7L19.3 4.1L21.4 6.2L16.8 10.8C17.5 11.4 18.1 12.1 18.6 12.9L21.8 10.7L23 11.9L20.8 14.1L18.6 11.9C17.8 12.4 17.1 13 16.5 13.7L19.2 17.5L17.5 19.2L13.7 16.5C13 17.1 12.3 17.6 11.5 17.9V20.3H10V17.9C9.2 17.6 8.5 17.1 7.8 16.5L4 19.2L2.3 17.5L5 13.7C4.4 13 3.9 12.3 3.5 11.5V9H1.5V7.5H3.5V9.5C4.3 9 5.1 8.6 6 8.3V5.3H7.5V7.8C8.4 8.1 9.2 8.5 10 9.1L14.7 8.7Z" fill="#FFA500"/>
              <path d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" stroke="#FFA500" stroke-width="2"/>
            </svg>
          </div>
          
          <h1 class="title">功能正在开发中</h1>
          
          <p class="subtitle">我们正在努力构建这个功能，敬请期待！</p>
          
          <div class="loading-indicator">
            <span class="dot"></span>
            <span class="dot"></span>
            <span class="dot"></span>
          </div>
          
          <div class="action-buttons">
            <button class="btn btn-primary" @click="goHome">
              <span>返回首页</span>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 4L4 12H8V20H16V12H20L12 4Z" fill="white"/>
              </svg>
            </button>
          </div>
          
          <div class="back-links">
            <router-link to="/site-navigation" class="link-text">查看网站地图</router-link>
          </div>
        </div>
      </div>
    </div>
    
    <!-- 尾部 -->
    <div class="header-footer-wrapper">
      <PageFooter />
    </div>
  </div>
</template>

<script>
import PageHeader from '../detail/components/PageHeader.vue'
import PageFooter from '../detail/components/PageFooter.vue'

export default {
  name: 'ComingSoon',
  components: {
    PageHeader,
    PageFooter
  },
  methods: {
    goHome() {
      this.$router.push('/')
    }
  }
}
</script>

<style scoped>
.coming-page {
  min-height: 100vh;
  background: #fff;
}

.header-footer-wrapper {
  max-width: 1400px;
  margin: 0 auto;
}

.coming-wrapper {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 20px;
}

.coming-container {
  min-height: calc(100vh - 400px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
}

.coming-content {
  text-align: center;
  max-width: 600px;
  width: 100%;
}

.icon-wrapper {
  margin-bottom: 32px;
}

.wrench-icon {
  width: 120px;
  height: 120px;
  animation: rotate 3s linear infinite;
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.title {
  font-size: 42px;
  font-weight: 700;
  color: #333;
  margin-bottom: 16px;
  line-height: 1.4;
}

.subtitle {
  font-size: 18px;
  color: #666;
  margin-bottom: 40px;
  line-height: 1.6;
}

.loading-indicator {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin-bottom: 48px;
}

.dot {
  width: 12px;
  height: 12px;
  background: #FFA500;
  border-radius: 50%;
  animation: bounce 1.4s infinite ease-in-out both;
}

.dot:nth-child(1) {
  animation-delay: -0.32s;
}

.dot:nth-child(2) {
  animation-delay: -0.16s;
}

@keyframes bounce {
  0%, 80%, 100% {
    transform: scale(0.8);
    opacity: 0.5;
  }
  40% {
    transform: scale(1);
    opacity: 1;
  }
}

.action-buttons {
  margin-bottom: 24px;
}

.btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 14px 32px;
  font-size: 16px;
  font-weight: 600;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s;
}

.btn-primary {
  background: linear-gradient(135deg, #FFA500 0%, #FF8C00 100%);
  color: white;
  box-shadow: 0 4px 12px rgba(255, 165, 0, 0.3);
}

.btn-primary:hover {
  background: linear-gradient(135deg, #FFB347 0%, #FFA029 100%);
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(255, 165, 0, 0.4);
}

.btn svg {
  transition: transform 0.3s;
}

.btn:hover svg {
  transform: translateX(4px);
}

.back-links {
  margin-top: 32px;
}

.link-text {
  font-size: 14px;
  color: #999;
  text-decoration: none;
  transition: color 0.3s;
}

.link-text:hover {
  color: #FFA500;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .title {
    font-size: 32px;
  }
  
  .subtitle {
    font-size: 16px;
  }
  
  .wrench-icon {
    width: 80px;
    height: 80px;
  }
  
  .btn {
    padding: 12px 24px;
    font-size: 14px;
  }
  
  .coming-wrapper {
    padding: 0 15px;
  }
}
</style>
